import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import { APP } from "../../../Definition";
import {
  Context,
  newStudentPath,
  editStudentPath,
  fetchClasses,
  fetchStudents,
  bulkEditStudentsPath,
  resetStudentPassword,
  clearTemporaryToken,
  fetchTemporaryToken,
  masqueradeStudent,
  MASQUERADE_STUDENT_SUCCESS_MESSAGE,
  clearSuccessMessage,
  disableStudentPlans,
  bulkRegisterStudentsPath,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import StudentList from "../../../templates/manager/StudentList";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import useSchoolStatus from "../../../hooks/manager/useSchoolStatus";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [loginCalling, loginPeep] = useWaitApiCall(state);
  const [resetPasswordCalling, resetPasswordPeep] = useWaitApiCall(state);
  const [passwordListCalling, passwordListPeep] = useWaitApiCall(state);
  const history = useHistory();
  const { currentYear } = useCurrentYear();
  const { isCramSchool } = useSchoolStatus();
  const [proxyLoginApp, setProxyLoginApp] =
    React.useState<typeof APP[keyof typeof APP]>();

  React.useEffect(() => {
    dispatch(fetchStudents());
    dispatch(fetchClasses(currentYear));
  }, [dispatch, currentYear]);

  const resetPasswordFunc = React.useCallback(
    (id: number) => dispatch(resetPasswordPeep(resetStudentPassword(id))),
    [dispatch, resetPasswordPeep],
  );

  const saveDisableStudentPlans = (id: number, end_at: string) => {
    dispatch(disableStudentPlans(id, end_at));
  };

  const clearTemporaryTokenFunc = React.useCallback(
    () => dispatch(clearTemporaryToken()),
    [dispatch],
  );

  const fetchTemporaryTokenFunc = React.useCallback(
    () => dispatch(passwordListPeep(fetchTemporaryToken())),
    [dispatch, passwordListPeep],
  );

  const toBuildNewStudent = React.useCallback(
    () => history.push(newStudentPath),
    [history],
  );
  const toBuildBulkNewStudents = React.useCallback(
    () => history.push(bulkRegisterStudentsPath),
    [history],
  );
  const toBulkEditStudents = React.useCallback(
    () => history.push(bulkEditStudentsPath),
    [history],
  );
  const toBuildStudent = React.useCallback(
    id => {
      history.push(`${editStudentPath}/${id}`);
    },
    [history],
  );
  const dlpLoginFunc = React.useCallback(
    (id: number) => {
      setProxyLoginApp(APP["dlp"]);
      dispatch(loginPeep(masqueradeStudent(id, APP["dlp"])));
    },
    [dispatch, loginPeep],
  );

  const gearLoginFunc = React.useCallback(
    (id: number) => {
      setProxyLoginApp(APP["g4s"]);
      dispatch(loginPeep(masqueradeStudent(id, APP["g4s"])));
    },
    [dispatch, loginPeep],
  );

  const handleAppUrl = React.useCallback(
    (app: typeof APP[keyof typeof APP]) => {
      const appURLs = {
        [APP["dlp"]]: process.env.REACT_APP_STUDENT_DLP_URL,
        [APP["g4s"]]: process.env.REACT_APP_STUDENT_APP_URL,
      };
      return appURLs[app];
    },
    [],
  );

  React.useEffect(() => {
    if (state.success_message === MASQUERADE_STUDENT_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      const appUrl = proxyLoginApp ? handleAppUrl(proxyLoginApp) : null;
      appUrl &&
        window.open(
          `${appUrl}?session_id=${state.temporary_session_id}`,
          "_blank",
        );
    }
  }, [
    dispatch,
    state.success_message,
    state.success_result,
    state.temporary_session_id,
    handleAppUrl,
    proxyLoginApp,
  ]);

  return (
    <div>
      <Breadcrumb
        currentTitle={
          isCramSchool ? titles.cramSchoolStudents : titles.students
        }
      />
      <StudentList
        title={isCramSchool ? titles.cramSchoolStudents : titles.students}
        loginCalling={loginCalling}
        resetPasswordCalling={resetPasswordCalling}
        passwordListCalling={passwordListCalling}
        resetPassword={resetPasswordFunc}
        toBuildNewStudent={toBuildNewStudent}
        toBuildBulkNewStudents={toBuildBulkNewStudents}
        toBulkEditStudents={toBulkEditStudents}
        toBuildStudent={toBuildStudent}
        fetchTemporaryToken={fetchTemporaryTokenFunc}
        clearTemporaryToken={clearTemporaryTokenFunc}
        temporary_token={state.temporary_token}
        students={state.students}
        classes={state.classes}
        school={state.manager.school!}
        isNextYear={false}
        dlpLogin={dlpLoginFunc}
        onSaveDisableStudentPlans={saveDisableStudentPlans}
        gearLogin={
          !!state.isMasqueradeByAdmin || state.manager!.school!.g4s_enabled
            ? gearLoginFunc
            : undefined
        }
        isMasqueradeByAdmin={state.isMasqueradeByAdmin}
      />
    </div>
  );
};
